import DataTables from '@/components/Studies/DataTables/Create/Show';

export default DataTables;
